import { r } from "../lib/default-reporter.js";
import { inspection } from "../data/inspections.js";
import { getImagesForPdf, getContextsIndex, getContextsIndexForInsp } from "../data/images.js";
import { rpsVrijgavemetingReport } from "../lib/RPS/inspectionTypes/Vrijgavemeting_report.js";

import { store } from "../inspx-store.js";

export const downloadPdfReport = (inspKey, reportName) => (dispatch, getState) => {
	_generatePdf(inspKey, reportName, false);
};

export const getPdfReportPreview = (inspKey, reportName) => (dispatch, getState) => {
	return _generatePdf(inspKey, reportName, true);
};

const prepareInspectionData = async (inspKey) => {
	let isRemote = false;
	let i = await inspection(inspKey).then(res => {
		if (!res) {
			const state = store.getState()
			res = state.inspection.remote.inspection
			isRemote = true;
		}
		return res;
	});
	let inspPromise = Promise.resolve(i);

	let rIinsp = store.getState().inspection.remote;
	const imgsPromise = getImagesForPdf(inspKey, rIinsp);
	const imgCtxIndexPromise = isRemote ? getContextsIndexForInsp(rIinsp.inspection, 'images') : getContextsIndex(inspKey, 'images');
	let signatureDataUrlProm = Promise.resolve(null);
	var imgDataArray;
	if (rIinsp && rIinsp.inspectorSignature && rIinsp.inspectorSignature[0]) {
		imgDataArray = rIinsp.inspectorSignature[0];
	} else if (localStorage && localStorage.profile) {
		imgDataArray = JSON.parse(localStorage.profile).signature;
	}

	if (imgDataArray) {
		const uint8Array = new Uint8Array(imgDataArray);
		const blob = new Blob([uint8Array], { type: "image/jpeg" });
		signatureDataUrlProm = new Promise((resolve, reject) => {
			var a = new FileReader();
			a.onload = function (e) {
				resolve(e.target.result);
			}
			a.onerror = function (err) {
				console.error(err);
				reject(err);
			}
			a.readAsDataURL(blob);
		})
	}

	return Promise.all([inspPromise, imgsPromise, imgCtxIndexPromise, signatureDataUrlProm])
}

const _generatePdf = (inspKey, reportName, isPreview) => {

	return prepareInspectionData(inspKey).then(results => {
		const inspection = results[0];
		const imgs = results[1];
		const imgCtxIndex = results[2];
		const signatureDataUrl = results[3];

		const data = {
			inspection: inspection,
			cover: imgs.cover,
			images: imgs.images || [],
			drawings: imgs.drawings || [],
			imagesContextIndex: imgCtxIndex,
			signature: signatureDataUrl
		};

		let eval2 = eval; //this is workaround for rollup (https://github.com/rollup/rollup/wiki/Troubleshooting#avoiding-eval)

		const namedReport = (reportName != undefined && reportName.length > 0)
			? inspection.type.reports.find((rep) => rep.name === reportName) : null;
		const getDocumentDefinitionFunc = namedReport
			? eval2("(" + namedReport.report + "\n)")
			: inspection.type.report
				? eval2("(" + inspection.type.report + "\n)")
				: r; //failback

		if (!getDocumentDefinitionFunc) {
			return;
		}

		const docDefinition = getDocumentDefinitionFunc(data);
		const pdfDocGenerator = pdfMake.createPdf(docDefinition);

		if (isPreview) {
			return new Promise((resolve, reject) => {
				pdfDocGenerator.getBlob(dataUrl => {
					resolve(dataUrl);
				});
			});
		}

		const fileName =
            inspection.name.replace(/[/\\?%*:|"<>]/g, "-") +
            " - Report - " +
            new Date().toString() +
            ".pdf";
		pdfDocGenerator.download(fileName);
	})
		.catch(err => {
			console.log(err)
		})
};
